document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.querySelector('[data-sidebar]');
  const toggle = document.querySelector('[data-menu-toggle]');
  const overlay = document.querySelector('[data-menu-overlay]');

  const setMenu = (open) => {
    if (!sidebar || !toggle || !overlay) return;
    sidebar.classList.toggle('is-open', open);
    document.body.classList.toggle('menu-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    overlay.hidden = !open;
  };

  toggle?.addEventListener('click', () => setMenu(!sidebar.classList.contains('is-open')));
  overlay?.addEventListener('click', () => setMenu(false));
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  document.querySelectorAll('[data-product-thumbnail]').forEach((button) => {
    button.addEventListener('click', () => {
      const target = document.querySelector('[data-product-main-image]');
      if (!target) return;
      target.src = button.dataset.imageSrc;
      target.srcset = '';
      target.alt = button.dataset.imageAlt || '';
      document.querySelectorAll('[data-product-thumbnail]').forEach((item) => item.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  document.querySelectorAll('[data-quantity-control]').forEach((control) => {
    const input = control.querySelector('input[type="number"]');
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.assign(url.toString());
    });
  });
});
